import { render } from "./AccountExpiredCard.vue?vue&type=template&id=0d2dfe5c&scoped=true"
import script from "./AccountExpiredCard.vue?vue&type=script&lang=js"
export * from "./AccountExpiredCard.vue?vue&type=script&lang=js"

import "./AccountExpiredCard.vue?vue&type=style&index=0&id=0d2dfe5c&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2dfe5c"]])

export default __exports__